import {connect} from "react-redux";
import {setProducts} from "../../Redux/actions/setProducts";
import Home from '../../Components/Home/Home'
import {setSearchQuery,setFilter} from "../../Redux/actions/filter";
import orderBy from 'lodash/orderBy'
import {removeFromCart} from "../../Redux/actions/carts";

const sortBy = (products, filterBy) => {
    switch (filterBy) {
        case 'all':
            return products;
        case 'high_price':
            return orderBy(products, ['price'], 'desc');
        case 'low_price':
            return orderBy(products, ['price'], 'asc');
        default:
            return products;
    }
};



const filterProducts = (products, searchQuery) => products.filter(el => el.productName.toLowerCase().indexOf(searchQuery.toLowerCase()) >= 0 )

const searchProducts = (products, filterBy, searchQuery) => {
    return sortBy(filterProducts(products, searchQuery), filterBy);
};


const mapStateToProps = ({products,filter,carts}) => ({
    products: products.items && searchProducts(products.items,filter.filterBy,filter.searchQuery) ,
    isReady: products.isReady,
    searchQuery:products.searchQuery,
    cartsTotal:carts.items,
});
const mapDispatchToProps = (dispatch) => ({
    setProducts:product => dispatch(setProducts(product)),
    setSearchQuerye:product => dispatch(setSearchQuery(product)),
    setFilter:typeProduct => dispatch(setFilter(typeProduct)),
    filterBy:product => dispatch(setFilter(product)),
    removeFromCart:productId => dispatch(removeFromCart(productId))
})
export default connect(mapStateToProps,mapDispatchToProps)(Home)
